var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "221px",
    height: "221px",
    viewBox: "0 0 221 221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6BC6D082-AA3C-4762-A706-F311ACB8472A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11.5852479%",
    y1: "17.8917995%",
    x2: "88.2431771%",
    y2: "81.3233907%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8852CC",
    stopOpacity: 0.172412817,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5270CC",
    stopOpacity: 0.0962975543,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD8AE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8852CC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-screen",
    transform: "translate(-799.000000, -166.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(799.000000, 166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Corporate-headquaters_511205",
    fill: "url(#linearGradient-1)",
    opacity: 0.643136161
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 110.5,
    cy: 110.5,
    r: 110.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.361111,58 L76.1944444,58 C68.907354,58 63,63.9322271 63,71.25 L63,150.75 C63,158.067773 68.907354,164 76.1944444,164 L155.361111,164 C156.818529,164 158,162.813555 158,161.35 L158,60.65 C158,59.1864454 156.818529,58 155.361111,58 Z M68.2777778,150.75 L68.2777778,71.25 C68.2777778,66.8593362 71.8221902,63.3 76.1944444,63.3 L78.8333333,63.3 L78.8333333,158.7 L76.1944444,158.7 C71.8221902,158.7 68.2777778,155.140664 68.2777778,150.75 Z M152.722222,158.7 L84.1111111,158.7 L84.1111111,63.3 L152.722222,63.3 L152.722222,158.7 Z M109.972222,113.173 C105.703355,109.602375 104.11909,103.728991 106.009767,98.4828928 C107.900443,93.2367945 112.860958,89.7420325 118.416667,89.7420325 C123.972376,89.7420325 128.93289,93.2367945 130.823567,98.4828928 C132.714243,103.728991 131.129978,109.602375 126.861111,113.173 C132.988129,116.321825 136.855782,122.638333 136.888889,129.55 C136.888889,131.013555 135.707418,132.2 134.25,132.2 L102.583333,132.2 C101.125915,132.2 99.9444444,131.013555 99.9444444,129.55 C99.9775517,122.638333 103.845204,116.321825 109.972222,113.173 Z M131.611111,126.9 C130.362409,120.724641 124.955521,116.286717 118.680556,116.286717 C112.40559,116.286717 106.998702,120.724641 105.75,126.9 L131.611111,126.9 Z M118.416667,95.1 C114.044412,95.1 110.5,98.6593362 110.5,103.05 C110.5,107.440664 114.044412,111 118.416667,111 C122.788921,111 126.333333,107.440664 126.333333,103.05 C126.333333,98.6593362 122.788921,95.1 118.416667,95.1 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.b4b0b6a6b3a637f1aa1c73430723d31b.svg";
export { ForwardRef as ReactComponent };